// Group assets derive their start/end dates from their child episodes or tracks
export const CHILD_ENTITY_LABEL = { series: 'episodes', podcast: 'episodes', music: 'tracks', audiobook: 'tracks' }
export const GROUP_ASSET_TYPES = Object.keys(CHILD_ENTITY_LABEL)
